import { escapeHtml} from '@/utils/commonUtils';
import router from '@/routes/index';

export const mustHeaderRenderer = (props: any): any => {
  const div = document.createElement('div');
  const em = document.createElement('em');
  const b = document.createElement('b');
  em.style.color = '#643cff';
  em.textContent = '*';
  const onMousedown = (ev: any): void => {
    ev.stopPropagation();
  };
  div.addEventListener('mousedown', onMousedown);
  b.textContent = props.columnInfo.header;
  div.appendChild(em);
  div.appendChild(b);
  return {
    getElement(): any {
      return div;
    },
    render(): void {},
    beforeDestroy(): void {
      div.removeEventListener('mousedown', onMousedown);
    }
  };
};
// 组件里的方法必须要有orderChange
export function orderChangeRenderer(props: any, that: any): any {
  const {grid, rowKey} = props;
  const div = document.createElement('div');
  div.classList.add(...['location_control', 'small']);
  div.setAttribute('style', 'float: initial; padding-left: 23px;');

  const span1 = document.createElement('span');
  const classList = ['controlBtn', 'actionBtn'];
  if (!rowKey) {
    classList.push('disabled');
  }
  span1.classList.add(...classList);
  span1.innerText = '▲';
  span1.addEventListener('click', (e): void => {
    if (!(e.target as HTMLSpanElement).classList.contains('disabled')) {
      const selectedRowKey = rowKey;
      that.orderChange(selectedRowKey, 'up');
    }
  });

  const span2 = document.createElement('span');
  const classList2 = ['controlBtn', 'actionBtn'];
  if (rowKey === grid.store.data.viewData.length - 1) {
    classList2.push('disabled');
  }
  span2.classList.add(...classList2);
  span2.innerText = '▼';
  span2.addEventListener('click', (e): void => {
    if (!(e.target as HTMLSpanElement).classList.contains('disabled')) {
      const selectedRowKey = rowKey;
      that.orderChange(selectedRowKey, 'down');
    }
  });

  div.appendChild(span1);
  div.appendChild(span2);
  return {
    getElement(): any {
      return div;
    },
    render(): void {}
  };
}
export const helpHeaderRenderer = (props: any): any => {
  const div = document.createElement('div');
  const b = document.createElement('b');
  const onMousedown = (ev: any): void => {
    ev.stopPropagation();
  };
  div.addEventListener('mousedown', onMousedown);
  b.textContent = props.columnInfo.header;
  const button = document.createElement('button');
  button.type = 'button';
  button.id = props.columnInfo.name + 'HelpBtn';
  button.classList.add('help');
  button.style.background = 'url(/static/ncp/css/img/sp.png) no-repeat -76px 0;';
  div.appendChild(b);
  div.appendChild(button);
  return {
    getElement(): any {
      return div;
    },
    render(): void {},
    beforeDestroy(): void {
      div.removeEventListener('mousedown', onMousedown);
    }
  };
};
export const boldHeaderRenderer = (props: any): any => {
  const b = document.createElement('b');
  const onMousedown = (ev: any): void => {
    ev.stopPropagation();
  };
  b.addEventListener('mousedown', onMousedown);
  b.textContent = props.columnInfo.header;

  return {
    getElement(): any {
      return b;
    },
    render(): void {},
    beforeDestroy(): void {
      b.removeEventListener('mousedown', onMousedown);
    }
  };
};

export const textWidthButtonRenderer = ({ text, buttonText, isShowButton = true, callback }) => {
  const wrapElement = document.createElement('div');
  wrapElement.innerText = text;

  if (isShowButton) {
    const buttonElement = document.createElement('button');
    const onClick = () => {
      callback();
    };

    buttonElement.innerText = buttonText;
    wrapElement.append(buttonElement);
    buttonElement.addEventListener('click', onClick);
  }

  return {
    getElement(): HTMLElement {
      return wrapElement;
    },
  };
};

/*
 * a href로 이동하게 되면 새로고침 되어 불필요한 오버헤드 발생
 * */
export const aHrefRenderer = (props: any): any => {
  const text = props.text || props.value.toString();
  const windowTarget = props?.target ?? '_parent';
  const linkTo = props.linkTo;

  let path: string;
  // linkTo가 object 형식으로 들어오면 urlString으로 변경
  if (typeof linkTo === 'string') {
    path = linkTo;
  } else {
    path = router.resolve(linkTo).href;
  }

  const aTag = document.createElement('a');
  aTag.href = path;
  aTag.target = windowTarget;
  aTag.innerHTML = escapeHtml(text.toString());

  const encodeDiv = document.createElement('div');
  encodeDiv.className = 'tui-grid-cell-content';
  encodeDiv.appendChild(aTag);

  return {
    getElement(): HTMLElement {
      return encodeDiv;
    },
    render(): void {},
  };
};

export const warpHeaderTit = ({columnInfo}: any): any => {
  const div = document.createElement('div');
  div.innerHTML = columnInfo.header;
  return {
    getElement(): any {
      return div;
    },
    render(): void {}
  };
};

export class HtmlEncodeRenderer {
  private el: any;
  private constructor(props: any) {
    let encodeDiv = document.createElement('div');
    encodeDiv.className = 'tui-grid-cell-content';
    encodeDiv.innerText = props.value;
    this.el = encodeDiv;
  }

  public getElement(): any {
    return this.el;
  }
}

export const reverseRowNumRenderer = ({ rowKey }, totalCount: number) => {
  const el = document.createElement('span');
  const text = document.createTextNode((totalCount - rowKey).toString())
  el.appendChild(text)

  return {
    getElement(): HTMLSpanElement {
      return el;
    }
  };
};
